import { render, staticRenderFns } from "./Utilities-Detail-Kue.vue?vue&type=template&id=29f08e95"
import script from "./Utilities-Detail-Kue.vue?vue&type=script&lang=js"
export * from "./Utilities-Detail-Kue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports